<div class="routing-performance-dashboard">
  <h2>Routing Performance Dashboard</h2>

  <div class="dashboard-actions">
    <button class="btn btn-primary" (click)="refreshData()">Refresh Data</button>
    <button class="btn btn-secondary" (click)="exportData()">Export Data</button>
    <button class="btn btn-warning" (click)="clearData()">Clear Data</button>
  </div>

  <!-- Overall Statistics -->
  <div class="performance-section">
    <h3>Overall Performance Statistics</h3>
    <div class="stats-grid">
      <div class="stat-card">
        <div class="stat-label">Total Navigations</div>
        <div class="stat-value">{{ performanceStats.totalNavigations | number }}</div>
      </div>
      <div class="stat-card">
        <div class="stat-label">Average Duration</div>
        <div class="stat-value" [class]="getPerformanceClass(performanceStats.averageDuration)">
          {{ performanceStats.averageDuration | number:'1.2-2' }}ms
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-label">Success Rate</div>
        <div class="stat-value" [class]="getSuccessRateClass(performanceStats.successRate)">
          {{ performanceStats.successRate | number:'1.2-2' }}%
        </div>
      </div>
      <div class="stat-card">
        <div class="stat-label">Error Count</div>
        <div class="stat-value error">{{ performanceStats.errorCount | number }}</div>
      </div>
    </div>
  </div>


  <!-- Slowest Routes -->
  <div class="performance-section">
    <h3>Slowest Routes (Top 10)</h3>
    <div class="slowest-routes">
      <table class="table">
        <thead>
          <tr>
            <th>Rank</th>
            <th>Route Name</th>
            <th>Average Duration (ms)</th>
            <th>Navigation Count</th>
            <th>Performance Rating</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let route of slowestRoutes; let i = index">
            <td>{{ i + 1 }}</td>
            <td>{{ route.routeName }}</td>
            <td [class]="getPerformanceClass(route.averageDuration)">
              {{ route.averageDuration | number:'1.2-2' }}
            </td>
            <td>{{ route.navigationCount | number }}</td>
            <td>
              <span class="performance-badge" [class]="getPerformanceClass(route.averageDuration)">
                <span *ngIf="route.averageDuration < 100">Fast</span>
                <span *ngIf="route.averageDuration >= 100 && route.averageDuration < 500">Moderate</span>
                <span *ngIf="route.averageDuration >= 500 && route.averageDuration < 1000">Slow</span>
                <span *ngIf="route.averageDuration >= 1000">Very Slow</span>
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <!-- Performance Report -->
  <div class="performance-section">
    <h3>Performance Report</h3>
    <div class="performance-report">
      <pre>{{ performanceReport }}</pre>
    </div>
  </div>

</div>